import React from 'react';
import Tabs from '@/finsight/ui/common/components/Tabs';

import styles from './TraceTileHeader/traceTileHeader.scss';

const TraceTileTabs = [
  { name: 'Trades', key: 'Trades', isDisabled: false },
];

export const TradesTab = () => {
  return (
    <div className={ styles.tabsContainer }>
      <Tabs tabs={ TraceTileTabs } activeTab="Trades" onSelect={ null } dataTest="traceTileWithChartTabs" />
    </div>
   );
};

export default TradesTab;
